import { alertView, type AlertSeverity, type AlertStatus, type AlertView } from '@occ/contracts';
import { get } from '../api/http';
import { ROUTES } from '../api/routes';

/**
 * Alertas (Módulo 7), consumidas por la vista de mapa (fase 3 del M8).
 *
 * `listAlertsQuery` no tiene filtro por cliente ni por sucursal — solo por
 * nodo —, así que la vista de mapa pide **todas** las que están `firing` en
 * una sola llamada y agrupa por `nodeId` en el cliente, en vez de una
 * petición por sucursal.
 */

const asArray = (payload: unknown): unknown[] => (Array.isArray(payload) ? payload : []);

export type AlertFilters = {
  status?: AlertStatus;
  severity?: AlertSeverity;
  nodeId?: string;
  ruleId?: string;
  limit?: number;
};

export const fetchAlerts = async (filters: AlertFilters = {}): Promise<AlertView[]> => {
  const payload = await get(ROUTES.alerts, undefined, filters);
  return asArray(payload).map((row) => alertView.parse(row));
};

/** Agrupa por nodo: es la forma que consume `buildGraph` para colorear cada hoja. */
export const groupAlertsByNode = (alerts: AlertView[]): Map<string, AlertView[]> => {
  const map = new Map<string, AlertView[]>();
  for (const alert of alerts) {
    const list = map.get(alert.nodeId);
    if (list) list.push(alert);
    else map.set(alert.nodeId, [alert]);
  }
  return map;
};
